import { useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { appSelector, appUserProfileSelector, appUserSelector, getProfileAction } from '@store/slices/app.slice';
import { tokenService } from '@services/token.service';
import { getMyTokensAction, tokenSelector } from '@store/slices/token.slice';
import { Box, Button, Card, Chip, Grid, Typography } from '@mui/material'
import { AppContainer } from '@shared/components/AppContainer';
import { QuickLinks } from '../components/QuickLinks';
import { TokenListSkeleton } from '@shared/skeletons/TokenListSkeleton';
import { FilteredToken } from '@shared/components/FilteredToken';
import { IToken } from '@interfaces/token';
import ExploreIcon from '@mui/icons-material/Explore';
import { DashboardHeader } from '@shared/components/DashboardHeader';
import { TokenLength } from '@shared/components/TokenLength';
import NoTokenImage from '@assets/images/noTokenIcon.png';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { AppNoToken } from '@shared/components/AppNoToken';
import MagnifierImage from '@assets/images/mdi_magnify.svg';

export const CustomerTokens = () => {
    const history = useHistory();
    const tokenSlice = useAppSelector(tokenSelector);
    const userProfile = useAppSelector(appUserProfileSelector);
    const dispatch = useAppDispatch();

    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('md'));

    const createTokenActivation = async (id: string) => {
        const response = await tokenService.createActivation(id);
        history.push(`/tokens/${response?.data?.data?.id}/scan`)
    }

    useEffect(() => {
        dispatch(getMyTokensAction())
        if (!userProfile || Object.keys(userProfile).length === 0) {
            dispatch(getProfileAction())
        }
    }, [])


    return (
        <AppContainer>
            <Grid sx={{ flexDirection: { md: 'row', xs: 'column-reverse' }, gridAutoFlow: { xs: 'dense', md: 'row' } }} container spacing={4} >
                <Grid item md={8} xs={12}>
                    <Box sx={{ display: { md: 'block', xs: 'none' } }}>
                        <DashboardHeader profile={userProfile} />
                    </Box>

                    {!tokenSlice.myTokenLoaded && (
                        <>
                            <TokenListSkeleton width="70%" />
                            <TokenListSkeleton width="90%" />
                            <TokenListSkeleton width="60%" />
                            <TokenListSkeleton width="70%" />
                        </>
                    )}

                    {tokenSlice.myTokenLoaded && (
                        <FilteredToken tokens={tokenSlice?.myTokens?.data}
                            emptyListMessage={
                                <AppNoToken
                                    icon={<img src={NoTokenImage} />}
                                    // title="You do not have any Memberships" body={'Explore the market by clicking the button below.'}>
                                    title="You do not have any Memberships" body={'Keep an eye out for more coming soon.'}>
                                    <Box my={3}>
                                        <Button size="large" component={Link} to={`/marketplace`} color="primary" variant="contained" >
                                            <ExploreIcon /> &nbsp;&nbsp; Explore marketplace
                                        </Button>
                                    </Box>
                                </AppNoToken>
                            }
                            searchNotMatchedMessage={
                                <AppNoToken
                                icon={<img src={MagnifierImage} />}
                                    title="This search does not match any Memberships you own" body={'Try a different search or explore the marketplace by clicking the button below.'}>
                                    {/*title="This search does not match any Memberships you own" body={'Try a different search.'}>*/}
                                    <Box my={3}>
                                        <Button size="large" component={Link} to={`/marketplace`} color="primary" variant="contained" >
                                            <ExploreIcon /> &nbsp;&nbsp; Explore marketplace
                                        </Button>
                                    </Box>
                                </AppNoToken>
                            }
                            actions={(token: IToken) => {
                                return (
                                    <>
                                        {token?.last_token_activation?.is_expired == false ? (
                                            <Chip
                                                label="Activated"
                                                variant="filled"
                                                color="success"
                                                size="medium"
                                            />
                                        ) :
                                        token?.is_bc_token_expired == true ? (
                                                <Chip
                                                    label="Token Expired"
                                                    variant="filled"
                                                    color="warning"
                                                    size="medium"
                                                />
                                        ) :
                                            <Button
                                                style={{minWidth: '82px', height: '40px'}}
                                                onClick={() => createTokenActivation(token?.id)}
                                                variant="contained"
                                                size="small"
                                                color="primary"
                                            >
                                                <Typography fontWeight={700} className={`button-label`}>
                                                    Membership Card
                                                </Typography>
                                            </Button>
                                        }
                                    </>
                                )
                            }} />

                    )}

                </Grid>
                <Grid item md={4} xs={12}>
                    <Box sx={{ display: { md: 'none', xs: 'flex' } }}>
                        <Box sx={{ width: '100%' }}>
                            <DashboardHeader profile={userProfile} />
                        </Box>
                        <Box sx={{ display: { xs: 'flex', md: 'none' }, width: '100%', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <TokenLength length={tokenSlice?.myTokens?.data?.length} />
                        </Box>
                    </Box>
                    {
                        smallScreen
                            ? <Card sx={{ padding: '16px' }}>
                                <QuickLinks />
                            </Card>
                            : <QuickLinks />
                    }
                </Grid>
            </Grid>
        </AppContainer>
    )
}
